import {Component, OnInit, OnDestroy} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: "app-nfc-scan-dialog",
  templateUrl: "./nfc-scan-dialog.component.html",
  styleUrls: ["./nfc-scan-dialog.component.scss"]
})
export class NfcScanDialogComponent implements OnInit, OnDestroy {
  status: 'scanning' | 'success' | 'error' = 'scanning';
  errorMessage: string = '';
  cardUid: string = '';
  private messageListener: any;

  constructor(private dialogRef: MatDialogRef<NfcScanDialogComponent>) {}

  ngOnInit() {
    this.setupNFCListener();
    this.triggerNFCScan();
  }

  ngOnDestroy() {
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
    }
  }

  setupNFCListener() {
    this.messageListener = (event: MessageEvent) => {
      const data = event.data;
      
      if (data.type === 'NFC_RESULT') {
        this.status = 'success';
        this.cardUid = data.uid;
        setTimeout(() => {
          this.dialogRef.close({success: true, uid: data.uid});
        }, 1000);
      } else if (data.type === 'NFC_ERROR') {
        this.status = 'error';
        this.errorMessage = data.error;
      } else if (data.type === 'NFC_SCANNING') {
        this.status = 'scanning';
      }
    };
    window.addEventListener('message', this.messageListener);
  }

  triggerNFCScan() {
    const reactNative = (window as any).ReactNativeWebView;
    if (!reactNative) {
      this.status = 'error';
      this.errorMessage = 'NFC not supported';
      return;
    }

    reactNative.postMessage(JSON.stringify({
      type: 'SCAN_NFC'
    }));
  }

  retry() {
    this.status = 'scanning';
    this.errorMessage = '';
    this.triggerNFCScan();
  }

  cancel() {
    this.dialogRef.close({success: false});
  }
}
